import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';
import { generatePath } from '~/utils/generatePath';

const paths = {
  create: '/vendors/deals/:deal_id/deal_estimation_headers',
  update: '/vendors/deals/:deal_id/deal_estimation_headers/:id',
  destroy: '/vendors/deals/:deal_id/deal_estimation_headers/:id',
  update_request:
    '/vendors/deals/:deal_id/deal_estimation_headers/:id/update_request',
  update_accept:
    '/vendors/deals/:deal_id/deal_estimation_headers/:id/update_accept',
  update_reject:
    '/vendors/deals/:deal_id/deal_estimation_headers/:id/update_reject'
};

export const create = async (
  dealId: number
): Promise<NskResponse<{ id: number }>> =>
  postRequest<{ id: number }, null>(
    paths.create.replace(':deal_id', String(dealId))
  );

export const update = async (
  dealId: number,
  dealEstimationHeaderId: number,
  status: 'reject' | 'cancel'
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    { status }
  );

export const destroy = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    paths.destroy
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId))
  );

export const updateRequest = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_request
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );

export const updateAccept = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_accept
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );

export const updateReject = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_reject
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );

export const updateNote = async (
  dealId: number,
  note: string
): Promise<NskResponse<void>> =>
  putRequest(
    generatePath(
      '/vendors/deals/:deal_id/deal_estimation_headers/update_note',
      { deal_id: dealId }
    ),
    { note }
  );
